import React from "react";
import ModalShell from "./ModalShell";
import Button from "../common/Button";

interface AssignmentModalLayoutProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  // Defaults to a single Done button that closes the modal
  footer?: React.ReactNode;
  message?: React.ComponentProps<typeof ModalShell>["message"];
}

// The wide two-panel assignment modals (users, exercises, challenges):
// ModalShell at its largest size, with the Done footer the flows all use.
const AssignmentModalLayout: React.FC<AssignmentModalLayoutProps> = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  footer = <Button onClick={onClose}>Done</Button>,
  message,
}) => (
  <ModalShell
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    subtitle={subtitle}
    size="6xl"
    layout="scroll"
    footer={footer}
    message={message}
  >
    {children}
  </ModalShell>
);

export default AssignmentModalLayout;
